module.exports = __webpack_public_path__ + "img/mas_buscados_3.3ad6dd55.png";